import { render, staticRenderFns } from "./BuyTimeButton.vue?vue&type=template&id=3e0f74fe&scoped=true"
import script from "./BuyTimeButton.vue?vue&type=script&lang=js"
export * from "./BuyTimeButton.vue?vue&type=script&lang=js"
import style0 from "./BuyTimeButton.vue?vue&type=style&index=0&id=3e0f74fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0f74fe",
  null
  
)

export default component.exports